import iconMetro from '@/assets/icon-metro.png';
import iconSiege from '@/assets/icon-siege.png';
import poiRestaurant from '@/assets/markerPOI/icon-restaurant.svg';
import poiSport from '@/assets/markerPOI/icon-sport.svg';
import poiSupermarket from '@/assets/markerPOI/icon-supermarket.svg';
import poiNursery from '@/assets/markerPOI/icon-nursery.svg';
import poi1 from '@/assets/Marker-1.png';
import poi2 from '@/assets/Marker-2.png';
import poi3 from '@/assets/Marker-3.png';
import poi4 from '@/assets/Marker-4.png';
import poi5 from '@/assets/Marker-5.png';
import poi6 from '@/assets/Marker-6.png';
import poi7 from '@/assets/Marker-7.png';
import poi8 from '@/assets/Marker-8.png';
import poi9 from '@/assets/Marker-9.png';
import poi10 from '@/assets/Marker-10.png';
import poiHome from '@/assets/Marker-home.png';
import poi1Active from '@/assets/Marker-1_HOVER.png';
import poi2Active from '@/assets/Marker-2_HOVER.png';
import poi3Active from '@/assets/Marker-3_HOVER.png';
import poi4Active from '@/assets/Marker-4_HOVER.png';
import poi5Active from '@/assets/Marker-5_HOVER.png';
import poi6Active from '@/assets/Marker-6_HOVER.png';
import poi7Active from '@/assets/Marker-7_HOVER.png';
import poi8Active from '@/assets/Marker-8_HOVER.png';
import poi9Active from '@/assets/Marker-9_HOVER.png';
import poi10Active from '@/assets/Marker-10_HOVER.png';
import poiHomeActive from '@/assets/Marker-home_HOVER.png';
import m1 from '@/assets/markerClusterer/m1.png';
import m2 from '@/assets/markerClusterer/m2.png';
import greyCrossCircle from '@/assets/grey-cross-circle.svg';
import placeHolderSite from '@/assets/placeholdersite.png';

export default {
  iconMetro,
  iconSiege,
  poiRestaurant,
  poiSport,
  poiSupermarket,
  poiNursery,
  poi1,
  poi2,
  poi3,
  poi4,
  poi5,
  poi6,
  poi7,
  poi8,
  poi9,
  poi10,
  poiHome,
  poi1Active,
  poi2Active,
  poi3Active,
  poi4Active,
  poi5Active,
  poi6Active,
  poi7Active,
  poi8Active,
  poi9Active,
  poi10Active,
  poiHomeActive,
  m1,
  m2,
  greyCrossCircle,
  placeHolderSite,
};
